<script>
	module.exports = {
		props: ['on-ready', 'route-context'],
		components: {
			articles: require('./teacher-tip-tabs/articles-tips.vue').default,
			audio: require('./teacher-tip-tabs/audio-tips.vue').default,
			stepreads: require('./teacher-tip-tabs/stepreads-tips.vue').default,
			pts: require('./teacher-tip-tabs/pts-tips.vue').default,
			aads: require('./teacher-tip-tabs/aads-tips.vue').default,
			howto: require('./teacher-tip-tabs/howto-tips.vue').default,
			'tab-container': require('components/tab-container.vue').default
		},
		data: function () {
			return {
				tabs: [
					{
						component: 'articles',
						label: 'Articles'
					},
					{
						component: 'audio',
						label: 'Audio'
					},
					{
						component: 'stepreads',
						label: 'StepReads™'
					},
					{
						component: 'pts',
						label: 'Paired Text'
					},
					{
						component: 'aads',
						label: 'Article-A-Day'
					},
					{
						component: 'howto',
						label: 'How to Use the Site'
					}
				],
				title: 'Teaching Tips'
			};
		},
		modelData: ['aadTeacherTipTab', 'teacherTipTab'],
		mounted() {
			this.$emit('data-ready');

			if (typeof this.onReady === 'function') {
				this.onReady();
			}
		},
		methods: {
			print: function () {
				window.print();
			}
		}
	};
</script>
<template>
	<main
		id="content"
		class="main"
		role="main">
		<header
			ref="header"
			class="main-header -has-nav">
			<div class="wrapper">
				<h1 class="main-header-title">Teaching Tips</h1>
				<button
					class="button -outline"
					v-if="aadTeacherTipTab === 'protocol' || aadTeacherTipTab === 'levels' || aadTeacherTipTab === 'tips'"
					v-on:click="print"
					style="float: right">
					Print
				</button>
				<tab-container
					class="print-hidden"
					model-key="teacherTipTab">
					<button
						v-for="tab in tabs"
						:key="tab.component"
						:data-tab="tab.component">
						{{ tab.label }}
					</button>
				</tab-container>
			</div>
		</header>
		<keep-alive>
			<component
				:is="teacherTipTab"
				:route-context="routeContext"
				ref="teacherTipTabPanel"
				:data-panel="teacherTipTab">
			</component>
		</keep-alive>
	</main>
</template>
